import React from 'react';
import {
  createFragmentContainer,
  graphql,
} from 'react-relay';
import {saveWrap} from "local-util"
import LoginMutation from 'mutations/LoginMutation';
import withBaseComponent from "components/Base"
import LinearProgress from '@material-ui/core/LinearProgress';
import { Link } from 'found';
import Card from "assets/material-admin/components/Card/Card";
import CardBody from "assets/material-admin/components/Card/CardBody";
import CardHeader from "assets/material-admin/components/Card/CardHeader";
import GridContainer from "assets/material-admin/components/Grid/GridContainer";
import GridItem from "assets/material-admin/components/Grid/GridItem";
import CustomInput from "assets/material-admin/components/CustomInput/CustomInput";
import Button from "assets/material-admin/components/CustomButtons/Button";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import loginPageStyle from "assets/material-admin/assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import Errors from 'components/Errors'
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      // email: "email133333333434343",      
      // password: "xxx",
      email: "",
      password: "",
      errors: []
    };
    
  }
  componentDidMount() {
    if (localStorage.getItem('userToken')) {
      this.props.router.replace('/home')
    } else {
      // we add a hidden class to the card and after 700 ms we delete it and the transition appears
      setTimeout(
        function() {
          this.setState({ cardAnimaton: "" });
        }.bind(this),
        200
      );
    }
    
    
  }
  login = saveWrapper => {    
    const { relay, viewer, router,  } = this.props;
    LoginMutation.commit({environment: this.props.routes[0].environment,
                          router,
                          email: this.state.email,
                          password: this.state.password,
                          saveWrapper
                         });    
  }
  render() {
    const { classes } = this.props;
    
    return (
      (
        <div className={classes.content}>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={6} md={4}>                
                <Card raised={true} login className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                     className={`${classes.cardHeader} ${classes.textCenter}`} >
                    <img
                       width={180}
                      height={80}
                      src={`/images/play.png`} />
                    <h4 className={classes.cardTitle}>Log in</h4>                      
                  </CardHeader>
                  <CardBody>                      
                    <CustomInput
                       labelText="Email"
                       id="email"
                       formControlProps={{
                         fullWidth: true
                       }}
                       inputProps={{
                         value: this.state.email,
                         onChange: (e) => this.setState({ email: e.target.value })
                      }}
                      />
                      <CustomInput
                         labelText="Password"
                         id="password"
                         formControlProps={{
                           fullWidth: true
                         }}
                         inputProps={{
                           type: "password",
                           value: this.state.password,
                           onChange: (e) => this.setState({ password: e.target.value })
                        }}
                        />
                  </CardBody>
                  <Errors setState={this.setState} errors={this.state.errors}/>
                  <div classes={classes.buttonArea}>
                    {this.state.syncing ? <LinearProgress color="primary" /> : <span/>}
                  </div>
                  <div className={classes.textCenter}>
                    <Button color="primary" size="lg" round
                            onClick={() => {
                              this.setState({syncing: true})            
                              this.login(                                
                                saveWrap(null,
                                         {onComplete: (data) => {
                                           this.setState({syncing: false})
                                           
                                         },
                                          onError: (errs) => {
                                            this.setState({errors: errs})
                                          },
                                          onSuccess: (data) => {
                                            this.setState({editing: false})                          
                                          }}))            
                      }}>
                      Login
                  </Button>                  </div>

                  <div className={classes.textCenter}>
                    <Button className={classes.forgot} color="danger" size="lg" round
                            onClick={() => {
                              this.props.router.push("/forgot")
                      }}>
                      Forgot Password
                    </Button>                    
                    </div>
                  
                </Card>                
              </GridItem>
            </GridContainer>            
          </div>
        </div>
      )
    )
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(LoginPage)

